export const izradi_vlastiti_dopis = {
    templateId: 50.1,
    category: 12,
    templateTitle: "Izradi vlastiti dopis",
    templateDescription: `<p>Pomoću ovog dokumenta možete samostalno kreirati vlastiti dopis.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Ovim dokumentom kreirate vlastite predloške dopisa..</p>
    <br>
    <p> U naslov upisujete predmet dopisa, a potom dodajete ili mijenjate tekst odnosno po želji dodajete preostale točke i upisujete njihov sadržaj.</p>
    <br>

    `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [
          {
        type: "input",
        required: true,
        placeholder: "Naziv primatelja",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
    ],
      suffix: "",
    }
  ],
  
  headline: "",
  
    title: 'PREDMET: ', 
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
        {
            title: '',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '- molim na ruke, ________________',
                    help: 'Po želji, slobodno upišite osobu kojoj želite dostaviti dopis.',
                    value: '',
                }],
        },
        {
          title: '',
          mandatory: true,
          exampleContent: true,
          statements: [
              {
                  type: 'text',
                  required: true,
                  mandatory: true,
                  editable: true,
                  content: 'Ovdje, te nadalje u ostale točke (koje dodajete samostalno) upisujete tekst po želji...',
                  value: '',
              },
          ],
          value: '',
      },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    statements: [
                      {
                        type: 'text',
                        mandatory: false,
                        editable: true,
                        content: "Dostaviti: ",                      }
                    ]
                  },
            ],
};










// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/50.1_izradi_vlastiti_dopis.ts